import React from 'react';
import { css } from 'glamor';
import * as theme from '../../theme';
import { FLAVOUR_COLOURS } from './constants/flavourColours';
import { TYPOGRAPHY } from './constants/typography';

/* The list of free bays in the Change-bay popover (DRI-2874). Slimmed from Nick's
 * preview BayOptionList to our availability data `{ id, label, zone }` — no
 * bollard-state dot / recommended badge / unavailable rows (those were sim-only;
 * this list is purely the bays free for the booking window). */
const option = css({
	display: 'flex',
	alignItems: 'center',
	width: '100%',
	textAlign: 'left',
	padding: '8px 10px',
	border: `1px solid ${theme.gray10}`,
	borderRadius: 4,
	background: 'white',
	cursor: 'pointer',
	':hover': { background: theme.gray05 },
});
const selectedOption = css({
	borderColor: FLAVOUR_COLOURS.primary,
	background: theme.gray05,
});

export const BayOptionList = ({ bays, selectedBayId, onSelect }) => (
	<div className={css({ display: 'grid', gap: 6 })}>
		{bays.map((bay) => (
			<button
				key={bay.id}
				type="button"
				aria-pressed={bay.id === selectedBayId}
				className={css(option, bay.id === selectedBayId && selectedOption)}
				onClick={() => onSelect(bay)}
			>
				<span className={TYPOGRAPHY.emphasis}>
					{bay.label}
					{bay.zone ? (
						<span className={TYPOGRAPHY.metadata}> · {bay.zone}</span>
					) : null}
				</span>
			</button>
		))}
	</div>
);
